import Vue from 'vue'
import VueRouter from 'vue-router'

const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [{
    path: '/login',
    name: 'Login',
    component: () => import('../views/login/Login.vue')
}, {
    path: '/',
    component: () => import('../views/Home.vue'),
    children: [{
        path: '/',
        component: () => import('../views/Index.vue')
    }, {
        path: '/index',
        component: () => import('../views/Index.vue')
    }, {
        path: '/buding/index',
        name: 'Index',
        component: () => import('../views/Index.vue')
    }, {
        path: 'buding/sys/user',
        name: 'SysUser',
        component: () => import('../views/sys/SysUser.vue')
    }, {
        path: 'buding/sys/param',
        name: 'SysParam',
        component: () => import('../views/sys/SysParam.vue')
    }, {
        path: 'buding/account/outflowData',
        name: 'OutFlowData',
        component: () => import('../views/account/OutflowData.vue')
    }, {
        path: 'buding/account/inflowData',
        name: 'InFlowData',
        component: () => import('../views/account/InflowData.vue')
    }, {
        path: 'buding/account/flowStatistics',
        name: 'FlowStatistics',
        component: () => import('../views/account/FlowStatistics.vue')
    }, {
        path: 'buding/account/flowType',
        name: 'FlowType',
        component: () => import('../views/account/FlowType.vue')
    }, {
        path: 'buding/account/circulate',
        name: 'Circulate',
        component: () => import('../views/account/Circulate.vue')
    }, {
        path: 'buding/account/balance',
        name: 'Balance',
        component: () => import('../views/account/Balance.vue')
    }, {
        path: 'buding/account/balanceCheck',
        name: 'BalanceCheck',
        component: () => import('../views/account/BalanceCheck.vue')
    }, {
        path: 'buding/account/goods',
        name: 'Goods',
        component: () => import('../views/account/Goods.vue')
    }, {
        path: 'buding/account/sundries',
        name: 'Sundries',
        component: () => import('../views/account/Sundries.vue')
    }, {
        path: 'buding/doc/docCouplet',
        name: 'DocCouplet',
        component: () => import('../views/doc/DocCouplet.vue')
    }, {
        path: 'buding/doc/docImage',
        name: 'DocImage',
        component: () => import('../views/doc/DocImage.vue')
    }, {
        path: 'buding/doc/docPlan',
        name: 'DocPlan',
        component: () => import('../views/doc/DocPlan.vue')
    }, {
        path: 'buding/doc/docSportsRecord',
        name: 'DocSportsRecord',
        component: () => import('../views/doc/DocSportsRecord.vue')
    }, {
        path: 'buding/doc/docIllRecordOld',
        name: 'DocIllRecordOld',
        component: () => import('../views/doc/DocIllRecordOld.vue')
    }, {
        path: 'buding/doc/docIllRecord',
        name: 'DocIllRecord',
        component: () => import('../views/doc/DocIllRecord.vue')
    }, {
        path: 'buding/doc/docMemorandum',
        name: 'DocMemorandum',
        component: () => import('../views/doc/DocMemorandum.vue')
    }, {
        path: 'buding/doc/docDaysMatter',
        name: 'DocDaysMatter',
        component: () => import('../views/doc/DocDaysMatter.vue')
    }, {
        path: 'buding/doc/docSiteAccount',
        name: 'DocSiteAccount',
        component: () => import('../views/doc/DocSiteAccount.vue')
    }, {
        path: 'buding/doc/docTodo',
        name: 'DocTodo',
        component: () => import('../views/doc/DocTodo.vue')
    }, {
        path: 'buding/game/dnfRoleDevelop',
        name: 'DnfRoleDevelop',
        component: () => import('../views/game/DnfRoleDevelop.vue')
    }, {
        path: 'buding/game/dnfCustomEquip',
        name: 'DnfCustomEquip',
        component: () => import('../views/game/DnfCustomEquip.vue')
    }, {
        path: 'buding/game/dnfNormalEquip',
        name: 'DnfNormalEquip',
        component: () => import('../views/game/DnfNormalEquip.vue')
    }, {
        path: 'buding/game/dnfNotebook',
        name: 'DnfNotebook',
        component: () => import('../views/game/DnfNotebook.vue')
    }, {
        path: 'buding/game/genshinRoleDevelop',
        name: 'GenshinRoleDevelop',
        component: () => import('../views/game/GenshinRoleDevelop.vue')
    }, {
        path: 'buding/game/genshinEquip',
        name: 'GenshinEquip',
        component: () => import('../views/game/GenshinEquip.vue')
    }, {
        path: 'buding/game/genshinRolePreference',
        name: 'GenshinRolePreference',
        component: () => import('../views/game/GenshinRolePreference.vue')
    }, {
        path: 'buding/game/genshinEquipStat',
        name: 'GenshinEquipStat',
        component: () => import('../views/game/GenshinEquipStat.vue')
    }, {
        path: 'buding/game/genshinEquipCategory',
        name: 'GenshinEquipCategory',
        component: () => import('../views/game/GenshinEquipCategory.vue')
    }, {
        path: 'buding/game/genshinHelper',
        name: 'GenshinHelper',
        component: () => import('../views/game/GenshinHelper.vue')
    }, {
        path: 'buding/game/srRoleDevelop',
        name: 'SrRoleDevelop',
        component: () => import('../views/game/SrRoleDevelop.vue')
    }, {
        path: 'buding/game/srEquip',
        name: 'SrEquip',
        component: () => import('../views/game/SrEquip.vue')
    }, {
        path: 'buding/game/srRolePreference',
        name: 'SrRolePreference',
        component: () => import('../views/game/SrRolePreference.vue')
    }, {
        path: 'buding/game/srEquipStat',
        name: 'SrEquipStat',
        component: () => import('../views/game/SrEquipStat.vue')
    }, {
        path: 'buding/game/srEquipCategory',
        name: 'SrEquipCategory',
        component: () => import('../views/game/SrEquipCategory.vue')
    }, {
        path: 'buding/game-ui/jump',
        name: 'Jump',
        component: () => import('../views/gama-ai/Jump.vue')
    }, {
        path: 'buding/game-ui/fighter',
        name: 'Fighter',
        component: () => import('../views/gama-ai/Fighter.vue')
    }, {
        path: 'buding/game-ui/mower',
        name: 'Mower',
        component: () => import('../views/gama-ai/Mower.vue')
    }, {
        path: 'buding/util/sqlQuery',
        name: 'SqlQuery',
        component: () => import('../views/util/SqlQuery.vue')
    }, {
        path: 'buding/util/musicPlayer',
        name: 'MusicPlayer',
        component: () => import('../views/util/MusicPlayer.vue')
    }, {
        path: 'buding/util/cssNamedColor',
        name: 'CssNamedColor',
        component: () => import('../views/util/CssNamedColor.vue')
    }, {
        path: 'buding/sys/featureList',
        name: 'FeatureList',
        component: () => import('../views/sys/FeatureList.vue')
    }, {
        path: 'buding/cmp/template',
        name: 'Template',
        component: () => import('../views/cmp/Template.vue')
    }, {
        path: 'buding/cmp/test',
        name: 'Test',
        component: () => import('../views/cmp/Test.vue')
    }, {
        path: 'buding/cmp/inlineEditTable',
        name: 'InlineEditTable',
        component: () => import('../views/cmp/InlineEditTable.vue')
    }, {
        path: 'buding/cmp/iconPreview',
        name: 'IconPreview',
        component: () => import('../views/cmp/IconPreview.vue')
    }, {
        path: 'system/projectList',
        name: 'ProjectList',
        component: () => import('../views/project/ProjectList.vue')
    }]
}]

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    next();
})

export default router